module.exports = __webpack_public_path__ + "src/assets/img/robot.025edce7.png";